import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import {
  Car,
  Factory,
  Wheat,
  UtensilsCrossed,
  ShoppingBag,
  Sofa,
  Ship,
  Package,
} from "lucide-react";

const ICONS = [Car, Factory, Wheat, UtensilsCrossed, ShoppingBag, Sofa, Ship, Package];

export default function Industries() {
  const { t } = useLang();
  const items = t("industries.items") || [];

  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16 max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="gold-divider" />
            <span className="label-gold">{t("industries.label")}</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-[1.1] tracking-tight mb-6">
            {t("industries.title")}
          </h2>
          <p className="text-neutral-400 leading-relaxed text-base lg:text-lg">
            {t("industries.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-sm overflow-hidden">
          {items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ delay: (i % 4) * 0.08 }}
                data-testid={`industry-card-${i}`}
                className="group relative bg-[#0D0D0F] p-8 hover:bg-[#161618] transition-colors"
              >
                <Icon
                  className="w-7 h-7 text-[#F2B705] mb-5 group-hover:scale-110 transition-transform"
                  strokeWidth={1.3}
                />
                <h3 className="font-display text-lg font-semibold text-white mb-3">
                  {it.t}
                </h3>
                <p className="text-sm text-neutral-400 leading-relaxed">{it.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
